





























import Vue from 'vue';
import api from '@/common/api';

export default Vue.extend({
  data() {
    return {
      cardAcceptanceDebit: false as boolean,
      cardAcceptanceCredit: false as boolean,
      isSubmitting: false as boolean,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      api
        .get('/card-acceptance')
        .then(({ data }) => {
          this.cardAcceptanceDebit = !!data.data.cardAcceptanceDebit;
          this.cardAcceptanceCredit = !!data.data.cardAcceptanceCredit;
        })
        .catch(() => {
          this.cardAcceptanceDebit = false;
          this.cardAcceptanceCredit = false;
        });
    },
    changeCardAcceptanceSettings() {
      api
        .put('/card-acceptance', { cardAcceptanceDebit: this.cardAcceptanceDebit, cardAcceptanceCredit: this.cardAcceptanceCredit })
        .then(() => {
          this.$toasted.success('Card Acceptance Setting updated successfully!');
        })
        .catch(({ response }) => {
          this.$toasted.error(response.data.message);
        });
    },
  },
  components: {
  },
});

